const Roles = {
  Admin: 1,
  GeneralUser: 2,
  Viewer: 3,
};
export default Roles;
